export default "__VITE_ASSET__sR93q0bd__"